/* eslint-disable global-require */
/* eslint-disable max-len */
import Core from './core/default.scss';
import SubscriptionScreen from './screens/subscription-screen/default.scss';
import SubscriptionCancellationScreen from './screens/subscription-cancellation-redirect/default.scss';
import PaymentIcon from '../components/PaymentIcon/styles/default.scss';
import ModuleHeader from '../components/ModuleBody/ModuleHeader/styles/default.scss';
import ModuleBody from '../components/ModuleBody/styles/default.scss';
import InlineSection from '../components/InlineSection/styles/default.scss';
import Divider from '../components/Divider/styles/default.scss';
import ExpandableSection from '../components/ExpandableSection/styles/default.scss';
import CancelSubscriptionModal from '../modal/modals/cancelSubscriptionModal/styles.scss';
import CancelSubscriptionConfirmationModal from '../modal/modals/cancelSubscriptionConfirmationModal/styles.scss';
import CancelSubscriptionFeedbackModal from '../modal/modals/cancelSubscriptionFeedbackModal/styles.scss';
import SkeletonElement from '../components/SkeletonElement/styles/default.scss';
import Loader from '../components/Loader/styles/default.scss';
import Error from '../components/Error/styles/default.scss';
import Subheader from '../components/Subheader/styles/default.scss';
import ModalWrapper from '../modal/components/Modal/default.scss';
import ModalHeader from '../modal/components/ModalHeader/default.scss';
import ModalButtons from '../modal/components/ModalButtons/default.scss';
import InvoicesModal from '../modal/modals/invoicesModal/styles.scss';
import InvoiceDetailsModal from '../modal/modals/invoiceDetailsModal/styles.scss';
import InvoiceItem from '../components/Invoices/InvoiceItem/styles/default.scss';
import InvoicesList from '../components/Invoices/InvoicesList/styles/default.scss';
import Snackbars from '../components/Snackbars/default.scss';
import SnackbarMessage from '../components/Snackbars/components/SnackbarMessage/default.scss';
import InvoiceDetails from '../components/Invoices/InvoiceDetails/styles/default.scss';
import PaymentDetails from '../components/Invoices/PaymentDetails/styles/default.scss';
import InfoBox from '../components/Invoices/InfoBox/styles/default.scss';
import ProductItem from '../components/Products/ProductItem/styles/default.scss';
import ProductsList from '../components/Products/ProductsList/styles/default.scss';
import Link from '../components/Link/styles/default.scss';
import Header from '../components/Header/styles/default.scss';
import Layout from '../components/Layout/styles/default.scss';
import LogInDialog from '../components/LogInDialog/styles/default.scss';
import SchibstedAwarenessInfo from '../components/SchibstedAwarenessInfo/styles/default.scss';
import Dropdown from '../components/Dropdown/styles/default.scss';
import SchibstedBrands from '../components/SchibstedBrands/styles/default.scss';
import UserDialog from '../components/UserDialog/styles/default.scss';
import SapiSubscriptionModuleDeliveryDetails
    from '../components/SapiSubscriptionModule/components/SubscriptionDetails/DeliveryDetails/styles/deafult.scss';
import SapiSubscriptionModuleDetailsHeader
    from '../components/SapiSubscriptionModule/components/SubscriptionDetails/DetailsHeader/styles/default.scss';
import SapiSubscriptionModuleDetailsSubHeader
    from '../components/SapiSubscriptionModule/components/SubscriptionDetails/DetailsSubHeader/styles/default.scss';
import SapiSubscriptionModuleITunesDetailsContent
    from '../components/SapiSubscriptionModule/components/SubscriptionDetails/ITunesDetailsContent/styles/default.scss';
import SapiSubscriptionModuleNonInstantDetailsContent
    from '../components/SapiSubscriptionModule/components/SubscriptionDetails/NonInstantDetailsContent/styles/default.scss';
import SapiSubscriptionModuleCreditBalance
    from '../components/SapiSubscriptionModule/components/SubscriptionDetails/CreditBalance/styles/default.scss';
import Step from '../components/Step/styles/default.scss';
import Box from '../components/Box/styles/default.scss';
import ConfirmationModal from '../modal/modals/confirmationModal/styles.scss';
import Alert from '../components/Alert/styles/default.scss';
import DeviationNotifications from '../components/DeviationNotifications/styles/default.scss';
import ContactForm from '../components/ContactSupport/ContactForm/styles/default.scss';
import ContactReceipt from '../components/ContactSupport/ContactReceipt/styles/default.scss';
import Footer from '../components/Footer/styles/default.scss';
import ScreenLoader from '../components/ScreenLoader/styles/default.scss';
/* PLOP_INJECT_IMPORT */

export default {
    Core,
    SubscriptionScreen,
    SubscriptionCancellationScreen,

    /* PLOP_INJECT_SCREEN_EXPORT */

    PaymentIcon,
    ModuleHeader,
    ModuleBody,
    InlineSection,
    Divider,
    ExpandableSection,
    SkeletonElement,
    Loader,
    Error,
    Subheader,
    InvoiceItem,
    InvoicesList,
    Snackbars,
    SnackbarMessage,
    InvoiceDetails,
    PaymentDetails,
    InfoBox,
    ProductItem,
    ProductsList,
    Link,
    Header,
    Layout,
    LogInDialog,
    SchibstedAwarenessInfo,
    Dropdown,
    SchibstedBrands,
    UserDialog,
    SapiSubscriptionModuleDeliveryDetails,
    SapiSubscriptionModuleDetailsHeader,
    SapiSubscriptionModuleDetailsSubHeader,
    SapiSubscriptionModuleITunesDetailsContent,
    SapiSubscriptionModuleNonInstantDetailsContent,
    SapiSubscriptionModuleCreditBalance,
    Step,
    Box,
    Alert,
    DeviationNotifications,
    ContactForm,
    ContactReceipt,
    Footer,
    ScreenLoader,
    /* PLOP_INJECT_COMPONENT_EXPORT */
    // Modals
    ModalWrapper,
    ModalHeader,
    ModalButtons,
    CancelSubscriptionModal,
    CancelSubscriptionConfirmationModal,
    CancelSubscriptionFeedbackModal,
    InvoicesModal,
    InvoiceDetailsModal,
    ConfirmationModal,
    /* PLOP_INJECT_MODAL_EXPORT */
};
